const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudenttc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "2000pt",
    height: "2000pt",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 1413.5625 149.96875 L 1225.609375 356.007812 L 1474.699219 405.984375 L 1639.289062 196.230469 Z M 1413.5625 149.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 308.257335 184.316267 C 307.157063 184.900154 307.127545 186.503821 307.636298 187.635985 C 308.145051 188.771179 309.030304 189.737673 309.337639 190.938024 C 309.783594 192.701806 308.894868 194.492105 308.105404 196.131381 C 307.312467 197.767375 306.582329 199.68824 307.322307 201.351255 ",
    transform: "matrix(13.498082,0,0,15.467477,-2920.203162,-2505.763005)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,44.705882%,40.392157%)",
      fillOpacity: 1
    },
    d: "M 1254.816406 651.453125 L 1203.980469 651.453125 L 1203.980469 637.105469 C 1203.980469 621.058594 1215.351562 607.992188 1229.398438 607.992188 C 1243.402344 607.992188 1254.769531 621.058594 1254.769531 637.105469 Z M 1254.816406 651.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 1656.054688 441.285156 C 1675.941406 498.320312 1684.414062 559.710938 1700.246094 618.445312 C 1722.273438 700.097656 1759.195312 779.921875 1755.269531 865.335938 C 1750.589844 929.796875 1727.355469 990.683594 1689.140625 1038.367188 C 1637.011719 1108.605469 1562.007812 1151.242188 1481.65625 1156.285156 C 1400.675781 1159.769531 1324.023438 1114.425781 1279.5625 1036.761719 C 1241.617188 965.742188 1239.34375 876.382812 1252.988281 794.636719 C 1266.632812 712.84375 1294.816406 635.316406 1314.390625 555.128906 C 1324.425781 504.558594 1337.625 454.902344 1353.808594 406.441406 C 1372.09375 358.988281 1401.167969 314.609375 1442.371094 293.105469 C 1536.457031 244.003906 1624.214844 350.09375 1656.054688 441.285156 Z M 1656.054688 441.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.313725%,22.352941%,26.666667%)",
      fillOpacity: 1
    },
    d: "M 1580.917969 321.164062 C 1501.050781 315.203125 1422.082031 343.125 1358.984375 399.609375 L 1332.894531 302.6875 L 1554.832031 224.242188 Z M 1580.917969 321.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1739.886719 1046.25 L 1666.84375 1426.054688 L 1303.464844 1426.054688 L 1230.425781 1046.25 C 1230.425781 885.050781 1344.445312 754.335938 1485.132812 754.335938 C 1625.820312 754.335938 1739.886719 885.050781 1739.886719 1046.25 Z M 1739.886719 1046.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1128.042969 1967.566406 L 1204.515625 1744.835938 C 1212.320312 1629.574219 1244.917969 1518.347656 1299.453125 1421.058594 L 1661.40625 1421.058594 L 1662.519531 1423.625 C 1707.199219 1526.417969 1729.183594 1640.210938 1726.417969 1754.96875 L 1699.128906 1967.660156 L 1459.046875 1967.660156 L 1427.34375 1899.710938 L 1384.800781 1967.660156 Z M 1128.042969 1967.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1586.492188 565.121094 C 1598.171875 585.707031 1622.207031 591.578125 1640.179688 578.1875 C 1658.148438 564.800781 1663.277344 537.246094 1651.59375 516.617188 C 1639.910156 496.03125 1615.832031 490.207031 1597.863281 503.59375 C 1579.890625 516.980469 1574.808594 544.535156 1586.492188 565.121094 Z M 1586.492188 565.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1,
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 384.240355 212.437235 C 384.917534 212.579419 385.508764 212.985513 385.885554 213.566369 C 386.262054 214.147477 386.394307 214.852838 386.248742 215.528651 ",
    transform: "matrix(13.498082,0,0,15.467477,-3570.230548,-2777.000763)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1398.3125 565.121094 C 1386.628906 585.707031 1362.59375 591.578125 1344.625 578.1875 C 1326.652344 564.800781 1321.527344 537.246094 1333.207031 516.617188 C 1344.890625 496.03125 1368.972656 490.207031 1386.941406 503.59375 C 1404.914062 516.980469 1409.996094 544.535156 1398.3125 565.121094 Z M 1398.3125 565.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1,
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 332.04841 212.437235 C 331.370942 212.579419 330.779712 212.985513 330.399739 213.566369 C 330.023238 214.147477 329.894459 214.852838 330.036551 215.528651 ",
    transform: "matrix(13.498082,0,0,15.467477,-3113.536267,-2777.000763)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1491.332031 832.507812 C 1525.175781 832.507812 1552.554688 801.054688 1552.554688 762.316406 L 1552.554688 626.191406 L 1430.0625 626.191406 L 1430.0625 762.316406 C 1430.0625 801.054688 1457.53125 832.507812 1491.332031 832.507812 Z M 1491.332031 832.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1430.0625 685.75 L 1430.0625 688.867188 C 1462.882812 724.03125 1509.746094 736.042969 1552.511719 720.316406 L 1552.511719 685.65625 C 1514.5625 710.414062 1468.054688 710.414062 1430.0625 685.65625 Z M 1430.0625 685.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1367.589844 474.480469 L 1367.589844 553.796875 C 1367.542969 568.285156 1369.285156 582.726562 1372.671875 596.710938 C 1381.144531 633.480469 1401.746094 665.070312 1430.0625 684.878906 C 1467.652344 711.195312 1514.921875 711.195312 1552.511719 684.878906 C 1580.828125 665.023438 1601.339844 633.4375 1609.855469 596.710938 C 1613.289062 582.726562 1614.984375 568.285156 1614.984375 553.796875 L 1614.984375 474.527344 C 1614.984375 391.222656 1559.644531 323.6875 1491.242188 323.6875 C 1458.019531 323.824219 1426.316406 339.824219 1403.753906 367.882812 C 1380.296875 396.816406 1367.367188 434.960938 1367.589844 474.480469 Z M 1367.589844 474.480469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 1609.632812 368.664062 C 1593.492188 384.113281 1574.851562 395.667969 1554.742188 402.730469 C 1506.9375 419.601562 1455.613281 416.941406 1406.785156 429.183594 C 1387.476562 433.859375 1368.925781 441.929688 1351.757812 453.070312 C 1353.1875 382.648438 1394.433594 321.441406 1453.5625 302.09375 C 1512.691406 282.746094 1575.921875 309.703125 1609.589844 368.664062 Z M 1609.632812 368.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,70.980392%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 1585.0625 777.675781 C 1582.921875 836.039062 1540.515625 881.792969 1489.546875 880.695312 C 1438.578125 879.546875 1397.734375 832.003906 1397.554688 773.59375 C 1397.554688 773.089844 1397.554688 772.539062 1397.554688 772.035156 C 1458.421875 746.632812 1525.398438 748.652344 1585.019531 777.628906 Z M 1585.0625 777.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1611.015625 591.945312 C 1610.703125 593.503906 1610.347656 595.0625 1609.945312 596.574219 C 1601.472656 633.34375 1580.917969 664.933594 1552.601562 684.738281 C 1515.007812 711.058594 1467.742188 711.058594 1430.152344 684.738281 C 1426.09375 681.898438 1422.167969 678.78125 1418.378906 675.480469 C 1396.21875 655.441406 1380.207031 627.796875 1372.761719 596.574219 C 1371.199219 590.339844 1370.042969 583.964844 1369.238281 577.546875 C 1375.882812 574.933594 1382.707031 572.824219 1389.660156 571.265625 C 1426.894531 562.28125 1464.976562 558.429688 1503.015625 559.757812 C 1533.558594 559.710938 1563.792969 566.542969 1592.0625 579.886719 C 1598.664062 583.277344 1604.996094 587.3125 1611.015625 591.945312 Z M 1611.015625 591.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 1440.050781 1071.421875 L 1440.050781 1967.566406 L 1092.546875 1967.566406 L 1266.277344 1410.972656 L 1209.242188 937.226562 C 1201.4375 872.167969 1240.234375 811.785156 1296.777344 801.101562 L 1349.574219 791.0625 L 1390.285156 871.890625 Z M 1440.050781 1071.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(70.588235%,88.235294%,93.72549%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 331.758459 260.898616 L 334.774802 266.124299 L 338.461668 279.024351 L 338.461668 336.211887 ",
    transform: "matrix(13.498082,0,0,15.467477,-3128.532637,-3244.474472)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1074.933594 209.847656 L 1037.027344 114.574219 C 1035.113281 109.804688 1034.976562 104.351562 1036.582031 99.398438 C 1038.1875 94.445312 1041.445312 90.457031 1045.636719 88.304688 C 1049.78125 86.101562 1054.554688 85.917969 1058.878906 87.753906 C 1063.160156 89.585938 1066.636719 93.300781 1068.554688 98.113281 L 1106.457031 193.386719 C 1108.332031 198.15625 1108.511719 203.609375 1106.90625 208.5625 C 1105.300781 213.515625 1102.042969 217.503906 1097.851562 219.65625 C 1093.707031 221.859375 1088.933594 222.042969 1084.609375 220.207031 C 1080.328125 218.375 1076.804688 214.660156 1074.933594 209.847656 Z M 1074.933594 209.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1031.542969 199.070312 L 998.5 115.996094 C 996.585938 111.179688 996.40625 105.726562 998.011719 100.820312 C 999.617188 95.867188 1002.871094 91.878906 1007.0625 89.679688 C 1011.253906 87.523438 1016.027344 87.292969 1020.308594 89.175781 C 1024.632812 91.007812 1028.109375 94.722656 1030.027344 99.535156 L 1063.070312 182.613281 C 1064.988281 187.378906 1065.121094 192.882812 1063.515625 197.789062 C 1061.910156 202.738281 1058.65625 206.730469 1054.464844 208.882812 C 1050.316406 211.085938 1045.546875 211.269531 1041.222656 209.433594 C 1036.941406 207.601562 1033.417969 203.839844 1031.542969 199.070312 Z M 1031.542969 199.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1007.910156 237.585938 L 974.824219 154.460938 C 972.90625 149.648438 972.773438 144.191406 974.378906 139.242188 C 975.984375 134.335938 979.238281 130.347656 983.386719 128.144531 C 987.578125 125.945312 992.347656 125.761719 996.671875 127.59375 C 1000.953125 129.429688 1004.433594 133.1875 1006.351562 137.957031 L 1039.390625 221.125 C 1041.308594 225.894531 1041.488281 231.394531 1039.882812 236.300781 C 1038.277344 241.253906 1035.023438 245.242188 1030.832031 247.394531 C 1026.640625 249.597656 1021.867188 249.78125 1017.585938 247.945312 C 1013.261719 246.113281 1009.785156 242.398438 1007.910156 237.585938 Z M 1007.910156 237.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 988.558594 276.507812 L 956.183594 194.855469 C 952.75 186.1875 956.050781 176.011719 963.628906 172.066406 C 971.167969 168.125 980.085938 171.929688 983.519531 180.59375 L 1015.890625 262.203125 C 1017.542969 266.375 1017.722656 271.097656 1016.292969 275.410156 C 1014.910156 279.671875 1012.101562 283.113281 1008.492188 285.035156 C 1000.910156 288.980469 992.035156 285.128906 988.558594 276.507812 Z M 988.558594 276.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,70.980392%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 1068.019531 192.46875 L 1034.976562 105.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,70.980392%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 1037.117188 216.171875 L 1004.074219 129.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,70.980392%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 1016.828125 261.105469 L 983.785156 174.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1032.570312 349.222656 C 1070.917969 371.003906 1117.429688 352.984375 1136.425781 309.015625 C 1155.421875 265.046875 1139.722656 211.773438 1101.332031 189.992188 C 1062.9375 168.261719 1016.425781 186.28125 997.476562 230.25 C 978.480469 274.21875 994.222656 327.492188 1032.570312 349.222656 Z M 1032.570312 349.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0.000237223 -0.000120274 L 1.466881 3.218832 ",
    transform: "matrix(13.498082,0,0,15.467477,980.528048,171.65811)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0.000945509 -0.000808242 L 1.467878 3.221174 ",
    transform: "matrix(13.498082,0,0,15.467477,1007.362237,139.160939)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M -0.00113093 0.000785952 L 1.465513 3.21999 ",
    transform: "matrix(13.498082,0,0,15.467477,1041.59339,125.472218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1314.570312 112.832031 L 971.703125 329.738281 C 946.597656 345.601562 915.027344 335.148438 901.203125 306.402344 C 887.335938 277.65625 896.429688 241.480469 921.535156 225.617188 L 1264.359375 8.710938 C 1289.464844 -7.152344 1321.035156 3.253906 1334.902344 32 C 1348.726562 60.75 1339.628906 96.921875 1314.570312 112.832031 Z M 1314.570312 112.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5.586919 3.843687 C 5.585911 1.720151 4.335504 0.000394208 2.793036 -0.00142088 C 1.249104 -0.000582981 0.00054129 1.720604 0.00142731 3.844362 C -0.000351323 5.966359 1.248591 7.688769 2.792523 7.687931 C 4.336456 7.687093 5.585141 5.965685 5.586919 3.843687 Z M 5.586919 3.843687 ",
    transform: "matrix(11.816416,-7.476585,6.524623,13.540446,878.509498,252.846925)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 26.220836 0.000890432 L 0.000386967 14.47784 ",
    transform: "matrix(13.498082,0,0,15.467477,949.131495,7.872946)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1137.273438 175.78125 C 1147.125 177.066406 1154.214844 187.199219 1153.101562 198.476562 L 1146.457031 267.476562 C 1146.144531 270.550781 1145.210938 273.484375 1143.78125 276.097656 C 1138.117188 292.648438 1122.691406 301.863281 1107.617188 297.644531 C 1092.546875 293.425781 1082.558594 277.105469 1084.207031 259.40625 C 1085.855469 241.757812 1098.699219 228.230469 1114.171875 227.820312 L 1117.472656 193.984375 C 1118.542969 182.703125 1127.417969 174.542969 1137.273438 175.78125 Z M 1137.273438 175.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 281.535471 168.73159 C 280.336227 168.601276 279.444318 167.563817 279.493804 166.357405 C 279.546763 165.150992 280.521149 164.19056 281.730233 164.16379 ",
    transform: "matrix(13.498082,0,0,15.467477,-2688.602991,-2311.383157)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 1253.34375 986.742188 L 1054.507812 818.066406 C 1015.046875 784.503906 992.125 731.183594 993.0625 674.882812 L 954.757812 351.835938 L 1205.320312 329.648438 L 1148.152344 676.351562 L 1345.605469 843.878906 C 1380.03125 873.082031 1387.296875 928.742188 1361.792969 968.171875 C 1336.328125 1007.648438 1287.769531 1015.945312 1253.34375 986.742188 Z M 1253.34375 986.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 1775.917969 1967.566406 L 1541.941406 1967.566406 L 1541.941406 1071.925781 L 1591.886719 871.890625 L 1632.554688 791.0625 L 1642.898438 791.0625 C 1689.363281 791.0625 1757.902344 870.515625 1757.367188 923.699219 L 1741.179688 1391.992188 Z M 1775.917969 1967.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(70.588235%,88.235294%,93.72549%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 377.090564 260.898616 L 373.311092 266.124299 L 369.611203 279.05996 L 369.611203 336.211887 ",
    transform: "matrix(13.498082,0,0,15.467477,-3447.100993,-3244.474472)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(98.039216%,44.705882%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 368.693092 258.604949 L 360.09378 269.919264 L 361.864576 296.454277 ",
    transform: "matrix(13.498082,0,0,15.467477,-3367.016849,-3222.294096)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(98.039216%,44.705882%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 336.4386 258.604949 L 345.037912 269.919264 L 343.267116 296.454277 ",
    transform: "matrix(13.498082,0,0,15.467477,-3167.893059,-3222.294096)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,71.764706%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 1501.632812 895.871094 C 1529.011719 901.003906 1547.605469 930.53125 1543.148438 961.9375 C 1538.6875 993.296875 1512.871094 1014.570312 1485.535156 1009.480469 C 1458.15625 1004.347656 1439.558594 974.773438 1444.019531 943.414062 C 1448.480469 912.054688 1474.296875 890.78125 1501.632812 895.871094 Z M 1501.632812 895.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 352.859749 284.151269 C 352.859749 282.648367 354.078672 281.430085 355.585251 281.430085 C 357.088359 281.430085 358.307282 282.648367 358.307282 284.151269 C 358.307282 285.656948 357.088359 286.875231 355.581779 286.875231 C 354.078672 286.875231 352.859749 285.653918 352.859749 284.151269 Z M 352.859749 284.151269 ",
    transform: "matrix(13.498082,0,0,15.467477,-3306.113482,-3442.4273)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 1435.546875 837.6875 C 1441.210938 885.738281 1422.613281 933.328125 1387.519531 960.425781 C 1351.132812 986.097656 1304.046875 979.222656 1274.4375 943.917969 C 1251.515625 913.660156 1248.261719 869.964844 1250.9375 829.988281 C 1255.21875 766.808594 1271.359375 705.417969 1298.292969 650.03125 C 1305.917969 634.445312 1329.105469 590.707031 1349.886719 602.074219 C 1364.109375 609.824219 1364.914062 653.335938 1369.863281 668.601562 C 1388.503906 726.507812 1428.589844 774.878906 1435.546875 837.6875 Z M 1435.546875 837.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1677.144531 1391.304688 C 1686.199219 1371.542969 1707.511719 1363.886719 1724.769531 1374.25 C 1742.027344 1384.609375 1748.671875 1409.046875 1739.617188 1428.808594 C 1730.566406 1448.566406 1709.25 1456.179688 1691.996094 1445.816406 C 1674.78125 1435.457031 1668.136719 1411.0625 1677.144531 1391.304688 Z M 1677.144531 1391.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1697.882812 1416.382812 L 1642.808594 1436.1875 C 1633.3125 1439.582031 1623.234375 1433.53125 1620.292969 1422.710938 C 1617.304688 1411.84375 1622.566406 1400.289062 1632.0625 1396.898438 L 1687.132812 1377.136719 C 1696.632812 1373.699219 1706.710938 1379.75 1709.652344 1390.617188 C 1712.640625 1401.4375 1707.378906 1412.988281 1697.882812 1416.382812 Z M 1697.882812 1416.382812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1817.566406 1465.027344 C 1826.664062 1434.492188 1810.699219 1397.171875 1788.894531 1379.382812 C 1755.941406 1352.5625 1710.234375 1361.410156 1686.820312 1399.144531 C 1686.019531 1400.472656 1685.304688 1401.804688 1684.59375 1403.132812 L 1684.414062 1402.996094 L 1615.5625 1513.902344 C 1609.992188 1522.933594 1611.863281 1535.449219 1619.710938 1541.914062 L 1620.648438 1542.648438 C 1628.539062 1549.066406 1639.464844 1546.957031 1645.085938 1537.925781 L 1647.894531 1533.386719 C 1642.320312 1542.417969 1644.191406 1554.933594 1652.039062 1561.398438 L 1652.976562 1562.132812 C 1660.871094 1568.550781 1671.792969 1566.441406 1677.414062 1557.410156 L 1684.324219 1546.269531 C 1678.75 1555.300781 1680.578125 1567.820312 1688.472656 1574.28125 L 1689.410156 1575.015625 C 1697.300781 1581.433594 1708.226562 1579.328125 1713.84375 1570.292969 L 1723.296875 1554.980469 C 1717.679688 1564.011719 1719.550781 1576.574219 1727.402344 1582.992188 L 1728.382812 1583.726562 C 1736.273438 1590.144531 1747.199219 1588.039062 1752.773438 1579.003906 C 1771.414062 1551.773438 1788.671875 1523.390625 1804.542969 1493.957031 C 1808.289062 1486.714844 1811.859375 1479.332031 1815.15625 1471.722656 C 1816.09375 1469.566406 1816.898438 1467.320312 1817.566406 1465.027344 Z M 1817.566406 1465.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.16729 -0.0000242824 L 0.00132566 1.639252 ",
    transform: "matrix(13.498082,0,0,15.467477,1645.200856,1514.312876)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.252173 0.00124703 L -0.00003071 1.761998 ",
    transform: "matrix(13.498082,0,0,15.467477,1678.973071,1529.285399)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.388363 -0.00000962758 L 0.00072409 1.950403 ",
    transform: "matrix(13.498082,0,0,15.467477,1713.744132,1540.035305)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 1866.082031 1471.355469 L 1650.257812 1365.996094 L 1800.308594 1162.796875 L 1636.65625 993.433594 C 1617.304688 973.398438 1606.824219 944.515625 1608.117188 914.667969 C 1609.410156 884.867188 1622.296875 857.265625 1643.257812 839.523438 C 1678.082031 810.089844 1726.554688 814.488281 1756.832031 849.929688 L 1974.171875 1103.972656 C 2006.902344 1142.257812 2008.820312 1202.824219 1978.585938 1243.71875 Z M 1866.082031 1471.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 360.390625 18.933594 L 172.480469 224.976562 L 421.570312 274.996094 L 586.117188 65.242188 Z M 360.390625 18.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 99.63572 162.547386 C 98.535737 163.131272 98.509113 164.734687 99.017866 165.867104 C 99.523436 167.002298 100.408689 167.968792 100.716024 169.169143 C 101.161979 170.929894 100.276725 172.723224 99.483789 174.3625 C 98.690852 175.998493 97.960714 177.919358 98.700981 179.582374 ",
    transform: "matrix(13.498082,0,0,15.467477,-1164.250514,-2295.822876)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,44.705882%,40.392157%)",
      fillOpacity: 1
    },
    d: "M 194.777344 524.640625 L 143.988281 524.640625 L 143.988281 510.289062 C 143.988281 494.242188 155.359375 481.175781 169.40625 481.175781 C 183.40625 481.175781 194.777344 494.242188 194.777344 510.289062 Z M 194.777344 524.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.313725%,22.352941%,26.666667%)",
      fillOpacity: 1
    },
    d: "M 527.746094 190.132812 C 447.882812 184.171875 368.910156 212.09375 305.8125 268.578125 L 279.769531 171.65625 L 501.703125 93.210938 Z M 527.746094 190.132812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.54902%,9.411765%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 274.953125 671.214844 L 605.824219 671.214844 L 605.824219 1967.566406 L 274.953125 1967.566406 Z M 274.953125 671.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 521.277344 1967.566406 L 780.671875 1967.566406 L 650.953125 1326.703125 L 391.5625 1326.703125 Z M 521.277344 1967.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 355.664062 1967.566406 L 96.273438 1967.566406 L 225.945312 1326.703125 L 485.339844 1326.703125 Z M 355.664062 1967.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 209.046875 1326.65625 L 667.898438 1326.65625 L 667.898438 1574.832031 L 209.046875 1574.832031 Z M 209.046875 1326.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 671.285156 1326.703125 L 205.613281 1326.703125 L 169.714844 822.972656 C 167.265625 788.492188 177.519531 754.382812 197.988281 728.9375 C 218.457031 703.445312 247.308594 689.003906 277.496094 689.003906 L 599.359375 689.003906 C 629.59375 689.003906 658.398438 703.445312 678.867188 728.9375 C 699.335938 754.382812 709.589844 788.492188 707.136719 822.972656 Z M 671.285156 1326.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,44.705882%,40.392157%)",
      fillOpacity: 1
    },
    d: "M 440.613281 229.972656 C 517.667969 229.972656 580.140625 301.542969 580.140625 389.890625 L 580.140625 390.808594 C 580.183594 478.652344 518.023438 549.855469 441.371094 549.855469 L 439.71875 549.855469 C 363.113281 549.808594 300.996094 478.605469 300.996094 390.808594 L 300.996094 389.84375 C 301.039062 301.542969 363.511719 229.972656 440.613281 229.972656 Z M 440.613281 229.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 440.390625 765.617188 C 474.191406 765.617188 501.613281 734.210938 501.613281 695.46875 L 501.613281 543.757812 L 379.164062 543.757812 L 379.164062 695.46875 C 379.164062 734.210938 406.542969 765.617188 440.390625 765.617188 Z M 440.390625 765.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 379.164062 603.269531 L 379.164062 606.429688 C 411.984375 641.597656 458.851562 653.65625 501.613281 637.929688 L 501.613281 603.269531 C 463.667969 627.980469 417.15625 627.980469 379.164062 603.269531 Z M 379.164062 603.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 440.390625 232.359375 C 372.074219 232.359375 316.648438 295.8125 316.648438 374.121094 L 316.648438 481.863281 C 316.648438 543.574219 360.300781 624.769531 414.167969 624.769531 L 466.609375 624.769531 C 520.476562 624.769531 564.132812 543.527344 564.132812 481.863281 L 564.132812 374.121094 C 564.132812 295.8125 508.703125 232.359375 440.390625 232.359375 Z M 440.390625 232.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 534.433594 475.71875 C 546.117188 501.988281 570.152344 509.464844 588.167969 492.363281 C 606.628906 471.914062 611.265625 439.957031 599.539062 413.730469 C 587.855469 387.460938 563.820312 379.941406 545.847656 397.042969 C 527.34375 417.539062 522.707031 449.492188 534.433594 475.71875 Z M 534.433594 475.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1,
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 177.200625 194.394268 C 178.611416 194.773592 179.509981 196.543183 179.212485 198.345604 ",
    transform: "matrix(13.498082,0,0,15.467477,-1827.560011,-2602.960657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 346.34375 475.71875 C 334.664062 501.988281 310.628906 509.464844 292.65625 492.363281 C 274.152344 471.914062 269.511719 439.957031 281.242188 413.730469 C 292.925781 387.460938 316.960938 379.941406 334.972656 397.042969 C 353.433594 417.539062 358.074219 449.492188 346.34375 475.71875 Z M 346.34375 475.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1,
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 125.008681 194.394268 C 123.59818 194.773592 122.699614 196.543183 122.996821 198.345604 ",
    transform: "matrix(13.498082,0,0,15.467477,-1370.865731,-2602.960657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 530.554688 369.121094 C 529.304688 369.121094 528.058594 368.710938 526.988281 367.929688 C 511.601562 357.429688 492.472656 357.203125 476.910156 367.335938 C 473.699219 369.535156 469.507812 368.296875 467.589844 364.582031 C 465.671875 360.824219 466.789062 356.054688 470 353.855469 C 489.929688 340.878906 514.410156 341.199219 534.121094 354.632812 C 536.84375 356.375 538.136719 360.042969 537.289062 363.484375 C 536.441406 366.921875 533.675781 369.261719 530.554688 369.121094 Z M 530.554688 369.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 349.914062 369.121094 C 351.160156 369.121094 352.410156 368.710938 353.480469 367.929688 C 368.863281 357.429688 387.992188 357.203125 403.558594 367.335938 C 406.765625 369.535156 410.957031 368.296875 412.875 364.582031 C 414.792969 360.824219 413.679688 356.054688 410.46875 353.855469 C 390.535156 340.878906 366.054688 341.199219 346.34375 354.632812 C 343.625 356.375 342.332031 360.042969 343.179688 363.484375 C 344.027344 366.921875 346.792969 369.261719 349.914062 369.121094 Z M 349.914062 369.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 381.125 468.886719 C 381.125 470.078125 380.28125 471.042969 379.253906 471.042969 C 378.226562 471.042969 377.382812 470.078125 377.382812 468.886719 C 377.382812 467.695312 378.226562 466.734375 379.253906 466.734375 C 380.28125 466.734375 381.125 467.695312 381.125 468.886719 Z M 381.125 468.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 397.714844 462.558594 C 397.714844 463.386719 397.089844 464.074219 396.378906 464.074219 C 395.664062 464.074219 395.085938 463.386719 395.085938 462.558594 C 395.085938 461.734375 395.664062 461.046875 396.378906 461.046875 C 397.089844 461.046875 397.714844 461.734375 397.714844 462.558594 Z M 397.714844 462.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 383.089844 452.613281 C 383.089844 453.847656 382.242188 454.859375 381.125 454.859375 C 380.058594 454.859375 379.210938 453.847656 379.210938 452.613281 C 379.210938 451.375 380.058594 450.363281 381.125 450.363281 C 382.242188 450.363281 383.089844 451.375 383.089844 452.613281 Z M 383.089844 452.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 365.742188 452.566406 C 366.859375 453.847656 366.859375 455.914062 365.742188 457.195312 C 364.628906 458.480469 362.800781 458.480469 361.683594 457.195312 C 360.570312 455.914062 360.570312 453.847656 361.683594 452.566406 C 362.800781 451.28125 364.628906 451.28125 365.742188 452.566406 Z M 365.742188 452.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 391.203125 485.210938 C 391.203125 486.859375 390 488.191406 388.574219 488.191406 C 387.148438 488.191406 385.988281 486.859375 385.988281 485.210938 C 385.988281 483.558594 387.148438 482.230469 388.574219 482.230469 C 390 482.230469 391.203125 483.558594 391.203125 485.210938 Z M 391.203125 485.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 406.855469 448.667969 C 406.855469 450.273438 406.007812 451.695312 404.714844 452.335938 C 403.421875 452.933594 401.90625 452.613281 400.925781 451.464844 C 399.945312 450.320312 399.632812 448.621094 400.167969 447.15625 C 400.703125 445.644531 401.996094 444.679688 403.378906 444.679688 C 405.296875 444.679688 406.855469 446.46875 406.855469 448.667969 Z M 406.855469 448.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 366.1875 473.242188 C 366.1875 474.800781 365.074219 476.085938 363.734375 476.085938 C 362.355469 476.085938 361.238281 474.800781 361.238281 473.242188 C 361.238281 471.636719 362.355469 470.402344 363.734375 470.402344 C 365.074219 470.402344 366.1875 471.636719 366.1875 473.242188 Z M 366.1875 473.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 409.355469 473.242188 C 409.355469 474.800781 408.238281 476.085938 406.855469 476.085938 C 405.472656 476.085938 404.359375 474.800781 404.359375 473.242188 C 404.359375 471.636719 405.472656 470.402344 406.855469 470.402344 C 408.238281 470.402344 409.355469 471.636719 409.355469 473.242188 Z M 409.355469 473.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 514.8125 468.886719 C 514.8125 470.078125 515.660156 471.042969 516.6875 471.042969 C 517.757812 471.042969 518.605469 470.078125 518.605469 468.886719 C 518.605469 467.695312 517.757812 466.734375 516.6875 466.734375 C 515.660156 466.734375 514.8125 467.695312 514.8125 468.886719 Z M 514.8125 468.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 498.269531 462.558594 C 498.269531 463.429688 498.894531 464.121094 499.609375 464.121094 C 500.367188 464.121094 500.988281 463.429688 500.988281 462.558594 C 500.988281 461.6875 500.367188 461 499.609375 461 C 498.894531 461 498.269531 461.6875 498.269531 462.558594 Z M 498.269531 462.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 516.777344 452.613281 C 516.777344 453.847656 515.882812 454.859375 514.8125 454.859375 C 513.742188 454.859375 512.851562 453.847656 512.851562 452.613281 C 512.851562 451.375 513.742188 450.363281 514.8125 450.363281 C 515.882812 450.363281 516.777344 451.375 516.777344 452.613281 Z M 516.777344 452.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 535.148438 454.859375 C 535.148438 456.691406 533.855469 458.160156 532.25 458.160156 C 530.6875 458.160156 529.394531 456.691406 529.394531 454.859375 C 529.394531 453.070312 530.6875 451.558594 532.25 451.558594 C 533.855469 451.558594 535.148438 453.070312 535.148438 454.859375 Z M 535.148438 454.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 504.78125 485.210938 C 504.78125 486.859375 505.941406 488.191406 507.410156 488.191406 C 508.839844 488.191406 509.996094 486.859375 509.996094 485.210938 C 509.996094 483.558594 508.839844 482.230469 507.410156 482.230469 C 505.941406 482.230469 504.78125 483.558594 504.78125 485.210938 Z M 504.78125 485.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 489.039062 448.667969 C 489.039062 450.273438 489.886719 451.695312 491.179688 452.335938 C 492.472656 452.933594 493.945312 452.613281 494.96875 451.464844 C 495.949219 450.363281 496.261719 448.621094 495.726562 447.15625 C 495.191406 445.644531 493.898438 444.679688 492.515625 444.679688 C 490.601562 444.679688 489.039062 446.46875 489.039062 448.667969 Z M 489.039062 448.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 529.75 473.242188 C 529.75 474.390625 530.375 475.445312 531.3125 475.855469 C 532.203125 476.316406 533.273438 476.085938 533.988281 475.261719 C 534.703125 474.433594 534.925781 473.242188 534.566406 472.144531 C 534.167969 471.089844 533.273438 470.402344 532.25 470.402344 C 530.910156 470.402344 529.796875 471.683594 529.75 473.242188 Z M 529.75 473.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 486.632812 473.242188 C 486.632812 474.390625 487.210938 475.445312 488.148438 475.855469 C 489.082031 476.316406 490.152344 476.085938 490.867188 475.261719 C 491.582031 474.433594 491.804688 473.195312 491.402344 472.144531 C 491 471.089844 490.109375 470.402344 489.082031 470.402344 C 487.746094 470.402344 486.632812 471.683594 486.632812 473.242188 Z M 486.632812 473.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 494.835938 514.140625 C 494.835938 518.035156 494.480469 521.933594 493.675781 525.691406 C 490.332031 542.335938 480.078125 556.042969 466.207031 562.371094 C 465.671875 562.648438 465.09375 562.875 464.515625 563.011719 C 459.652344 565.214844 454.480469 566.316406 449.261719 566.269531 C 436.957031 566.269531 425.183594 560.492188 416.667969 550.3125 C 415.773438 549.351562 414.925781 548.296875 414.167969 547.242188 C 409.621094 541.007812 406.410156 533.625 404.894531 525.691406 C 404.136719 521.933594 403.734375 518.035156 403.78125 514.183594 L 403.78125 513.773438 L 449.261719 514.183594 Z M 494.835938 514.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,44.705882%,40.392157%)",
      fillOpacity: 1
    },
    d: "M 464.515625 563.011719 C 459.652344 565.214844 454.480469 566.316406 449.261719 566.269531 C 436.957031 566.269531 425.183594 560.492188 416.667969 550.3125 C 422.152344 545.132812 429.019531 542.335938 436.109375 542.429688 C 448.238281 542.472656 459.296875 550.449219 464.515625 563.011719 Z M 464.515625 563.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 494.835938 514.140625 C 494.835938 518.035156 494.480469 521.933594 493.675781 525.691406 L 404.894531 525.691406 C 404.136719 521.933594 403.734375 518.035156 403.78125 514.140625 L 403.78125 513.773438 L 449.261719 514.140625 Z M 494.835938 514.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 312.855469 448.667969 C 306.300781 448.667969 300.996094 442.570312 300.996094 435.097656 L 300.996094 316.121094 C 300.996094 308.601562 306.300781 302.550781 312.855469 302.550781 C 319.410156 302.550781 324.71875 308.601562 324.71875 316.121094 L 324.71875 435.097656 C 324.71875 442.570312 319.410156 448.667969 312.855469 448.667969 Z M 312.855469 448.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 567.832031 448.667969 C 561.277344 448.667969 555.972656 442.570312 555.972656 435.097656 L 555.972656 316.121094 C 555.972656 308.601562 561.277344 302.550781 567.832031 302.550781 C 574.386719 302.550781 579.695312 308.601562 579.695312 316.121094 L 579.695312 435.097656 C 579.695312 442.570312 574.386719 448.667969 567.832031 448.667969 Z M 567.832031 448.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 371.316406 330.472656 C 386.835938 329.554688 401.058594 320.292969 409.710938 305.53125 C 417.960938 290.035156 414.4375 269.816406 401.59375 259.132812 C 420.234375 282.058594 443.289062 299.570312 468.929688 310.300781 C 477.355469 315.34375 487.480469 315.066406 495.683594 309.613281 C 501.792969 302.550781 503.265625 291.777344 499.339844 282.882812 C 495.328125 274.355469 489.753906 266.882812 482.976562 261.058594 C 494.078125 281.691406 510.308594 298.011719 529.574219 308.007812 C 549.105469 317.863281 571.535156 316.808594 590.308594 305.117188 C 608.992188 292.738281 618.933594 268.300781 615.234375 243.957031 C 609.394531 213.972656 582.101562 196.78125 556.773438 186.875 C 514.859375 169.269531 469.640625 164.457031 425.628906 172.9375 C 381.351562 181.878906 342.0625 210.855469 316.691406 253.402344 C 305.675781 273.117188 300.101562 292.28125 316.335938 309.246094 C 331.316406 324.742188 351.207031 332.398438 371.316406 330.472656 Z M 371.316406 330.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 561.945312 507.214844 C 552.761719 563.976562 513.519531 625.917969 466.476562 625.917969 L 413.992188 625.917969 C 366.992188 625.917969 327.796875 563.929688 318.566406 507.171875 C 393.925781 457.609375 486.585938 457.609375 561.945312 507.171875 Z M 561.945312 507.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 406.8125 916.5 L 339.878906 1967.566406 L 72.238281 1967.566406 L 170.785156 1386.671875 L 158.347656 828.289062 C 158.347656 741.546875 212.835938 671.261719 280.082031 671.261719 L 296.980469 671.261719 Z M 406.8125 916.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(70.588235%,88.235294%,93.72549%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 124.735676 240.320308 L 132.872248 256.178431 L 127.910316 323.461748 ",
    transform: "matrix(13.498082,0,0,15.467477,-1385.997089,-3045.933873)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 464.78125 916.5 L 521.277344 1967.566406 L 799.355469 1967.566406 L 700.804688 1386.671875 L 713.246094 828.289062 C 713.246094 741.546875 658.710938 671.261719 591.46875 671.261719 L 574.566406 671.261719 Z M 464.78125 916.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(70.588235%,88.235294%,93.72549%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 165.748567 240.320308 L 157.615177 256.178431 L 161.757838 323.461748 ",
    transform: "matrix(13.498082,0,0,15.467477,-1662.72137,-3045.933873)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 659.335938 1283.882812 C 669.992188 1265.222656 691.886719 1259.996094 708.164062 1272.28125 C 724.441406 1284.523438 728.945312 1309.554688 718.285156 1328.214844 C 707.585938 1346.875 685.734375 1352.058594 669.457031 1339.816406 C 653.183594 1327.574219 648.632812 1302.496094 659.335938 1283.882812 Z M 659.335938 1283.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 677.796875 1311.160156 L 621.253906 1324.59375 C 611.535156 1326.886719 602.035156 1319.734375 600.027344 1308.640625 C 598.023438 1297.5 604.265625 1286.585938 613.984375 1284.292969 L 670.484375 1270.859375 C 680.203125 1268.570312 689.703125 1275.722656 691.753906 1286.863281 C 693.761719 1297.957031 687.519531 1308.867188 677.796875 1311.160156 Z M 677.796875 1311.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 792.664062 1373.195312 C 804.347656 1343.804688 791.683594 1304.835938 771.527344 1284.707031 C 741.074219 1254.21875 694.832031 1257.839844 668.253906 1292.777344 C 667.316406 1293.96875 666.515625 1295.207031 665.710938 1296.445312 L 665.535156 1296.304688 L 587.453125 1398.824219 C 581.121094 1407.210938 581.878906 1419.867188 589.148438 1427.15625 L 589.996094 1428.027344 C 597.308594 1435.273438 608.367188 1434.402344 614.742188 1426.101562 L 617.910156 1421.882812 C 611.578125 1430.273438 612.335938 1442.929688 619.605469 1450.21875 L 620.496094 1451.089844 C 627.765625 1458.332031 638.824219 1457.460938 645.199219 1449.164062 L 653.046875 1438.847656 C 646.714844 1447.191406 647.472656 1459.890625 654.742188 1467.183594 L 655.589844 1468.054688 C 662.902344 1475.296875 673.960938 1474.425781 680.339844 1466.082031 L 691.128906 1451.960938 C 684.753906 1460.304688 685.511719 1473.003906 692.824219 1480.292969 L 693.671875 1481.164062 C 700.941406 1488.410156 712 1487.585938 718.375 1479.238281 C 739.289062 1454.207031 758.910156 1427.890625 777.238281 1400.335938 C 781.652344 1393.550781 785.796875 1386.582031 789.722656 1379.429688 C 790.835938 1377.410156 791.816406 1375.347656 792.664062 1373.195312 Z M 792.664062 1373.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.323097 0.00110025 L -0.00145505 1.515619 ",
    transform: "matrix(13.498082,0,0,15.467477,614.67589,1404.400951)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.422062 0.00115977 L 0.00172092 1.628566 ",
    transform: "matrix(13.498082,0,0,15.467477,646.828333,1423.286749)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.572591 -0.0014383 L 0.0000296 1.803761 ",
    transform: "matrix(13.498082,0,0,15.467477,680.2496,1438.135528)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 793.289062 1415.191406 L 625.535156 1234.824219 L 772.199219 1028.417969 L 605.734375 862.722656 C 586.070312 843.144531 575.101562 814.488281 575.90625 784.644531 C 576.664062 754.796875 589.105469 726.921875 609.792969 708.71875 C 644.085938 678.503906 692.644531 681.851562 723.503906 716.605469 L 945.035156 965.835938 C 978.390625 1003.429688 981.289062 1063.902344 951.769531 1105.441406 Z M 793.289062 1415.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(28.235294%,26.666667%,29.803922%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 223.316918 298.8515 C 221.265411 297.941325 218.863739 298.466115 217.380311 300.149587 ",
    transform: "matrix(13.498082,0,0,15.467477,-2165.768082,-3606.166068)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(98.039216%,44.705882%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 161.539532 241.599367 L 152.94022 252.913683 L 154.711016 279.448695 ",
    transform: "matrix(13.498082,0,0,15.467477,-1623.387945,-3058.338791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(98.039216%,44.705882%,40.392157%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 129.28633 241.599367 L 137.885352 252.913683 L 136.114557 279.448695 ",
    transform: "matrix(13.498082,0,0,15.467477,-1424.27766,-3058.338791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,71.764706%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 449.085938 796.882812 C 476.464844 802.019531 495.058594 831.546875 490.601562 862.90625 C 486.140625 894.3125 460.320312 915.585938 432.941406 910.496094 C 405.609375 905.359375 387.011719 875.789062 391.472656 844.429688 C 395.929688 813.070312 421.707031 791.796875 449.085938 796.882812 Z M 449.085938 796.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 145.707188 267.151496 C 145.707188 265.648847 146.926111 264.427535 148.429218 264.430565 C 149.932325 264.430565 151.151538 265.648847 151.151538 267.151496 C 151.151538 268.657428 149.932325 269.87571 148.429218 269.87571 C 146.926111 269.87571 145.707188 268.654398 145.707188 267.151496 Z M 145.707188 267.151496 ",
    transform: "matrix(13.498082,0,0,15.467477,-1562.498071,-3278.471995)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 583.484375 1199.429688 L 333.636719 1544.941406 C 315.355469 1570.203125 282.625 1573.734375 260.550781 1552.78125 C 238.523438 1531.828125 235.445312 1494.324219 253.726562 1469.0625 L 503.578125 1123.503906 C 521.859375 1098.195312 554.589844 1094.710938 576.664062 1115.664062 C 598.734375 1136.617188 601.8125 1174.121094 583.484375 1199.429688 Z M 583.484375 1199.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 118.558068 378.051986 C 120.193428 379.409421 120.721859 381.469439 119.737634 382.652365 C 118.753119 383.837816 116.628974 383.704471 114.993615 382.352845 C 113.361728 381.001219 112.833007 378.93817 113.817522 377.752466 C 114.802037 376.569793 116.922998 376.700359 118.558068 378.051986 Z M 118.558068 378.051986 ",
    transform: "matrix(13.498082,0,0,15.467477,-1289.904201,-4363.685998)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 19.111768 -0.0000440592 L 0.000546332 23.063976 ",
    transform: "matrix(13.498082,0,0,15.467477,281.367626,1106.54365)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,17.647059%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 290.605469 1411.84375 L 390.625 1174.441406 L 189.023438 1042.21875 L 292.34375 819.027344 C 304.5625 792.667969 305.8125 761.398438 295.6875 733.84375 C 285.609375 706.335938 265.277344 685.472656 240.304688 676.992188 C 198.789062 662.871094 154.554688 685.976562 136.628906 731.136719 L 8.117188 1054.917969 C -11.238281 1103.699219 4.996094 1161.328125 45.574219 1187.921875 Z M 290.605469 1411.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(28.235294%,26.666667%,29.803922%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 118.279329 288.684809 L 103.343759 280.136126 L 111.001386 265.706655 ",
    transform: "matrix(13.498082,0,0,15.467477,-1205.91911,-3290.784108)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(28.235294%,26.666667%,29.803922%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 88.566754 305.000473 C 90.152338 303.414737 92.587001 303.041221 94.572526 304.07868 ",
    transform: "matrix(13.498082,0,0,15.467477,-1081.547728,-3655.290786)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 405.785156 1219.007812 C 391.25 1204.199219 368.953125 1205.664062 356.023438 1222.355469 C 343.089844 1238.996094 344.382812 1264.535156 358.921875 1279.386719 C 373.457031 1294.199219 395.753906 1292.730469 408.730469 1276.042969 C 421.660156 1259.398438 420.367188 1233.863281 405.785156 1219.007812 Z M 405.785156 1219.007812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 394.148438 1250.917969 L 451.761719 1247.066406 C 461.660156 1246.425781 469.242188 1236.660156 468.660156 1225.332031 C 468.082031 1213.964844 459.5625 1205.296875 449.664062 1205.984375 L 392.050781 1209.835938 C 382.109375 1210.480469 374.570312 1220.199219 375.152344 1231.570312 C 375.730469 1242.9375 384.203125 1251.605469 394.148438 1250.917969 Z M 394.148438 1250.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 297.203125 1344.953125 C 279.277344 1320.054688 282.667969 1278.65625 297.5625 1253.210938 C 320.082031 1214.742188 365.5625 1204.425781 399.1875 1230.285156 C 400.300781 1231.15625 401.371094 1232.121094 402.441406 1233.082031 L 402.574219 1232.898438 L 501.214844 1308.683594 C 509.195312 1314.875 511.335938 1327.300781 505.984375 1336.515625 L 505.359375 1337.617188 C 499.964844 1346.785156 489.082031 1349.261719 481.058594 1343.117188 L 477 1340 C 485.027344 1346.1875 487.167969 1358.660156 481.769531 1367.828125 L 481.148438 1368.929688 C 475.75 1378.144531 464.914062 1380.574219 456.84375 1374.429688 L 446.945312 1366.820312 C 454.972656 1373.011719 457.113281 1385.433594 451.714844 1394.652344 L 451.089844 1395.75 C 445.695312 1404.921875 434.816406 1407.394531 426.789062 1401.253906 L 413.1875 1390.800781 C 421.214844 1396.988281 423.355469 1409.414062 417.960938 1418.628906 L 417.335938 1419.730469 C 411.941406 1428.898438 401.105469 1431.375 393.03125 1425.230469 C 367.214844 1407.304688 342.289062 1387.726562 318.339844 1366.589844 C 312.589844 1361.320312 306.96875 1355.816406 301.574219 1350.085938 C 300.015625 1348.480469 298.542969 1346.785156 297.203125 1344.953125 Z M 297.203125 1344.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0.000477142 0.0012071 L 1.672011 1.121501 ",
    transform: "matrix(13.498082,0,0,15.467477,458.934966,1327.465704)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0.000347377 0.00108388 L 1.797478 1.204466 ",
    transform: "matrix(13.498082,0,0,15.467477,430.885936,1355.662923)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(20.392157%,17.647059%,22.745098%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M -0.0000393786 0.000559585 L 1.988669 1.334508 ",
    transform: "matrix(13.498082,0,0,15.467477,399.988813,1380.565563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudenttc);
export default __webpack_public_path__ + "static/media/studenttc.332908c61f65c5e9f84cf43d221ad46c.svg";
export { ForwardRef as ReactComponent };